// extracted by mini-css-extract-plugin
module.exports = {"kofi":"KofiWidget_kofi__2w93q"};